<template>
    <div v-if="myfade">
        <header class="mui-bar mui-bar-nav mainHeader">
			<a class="mui-pull-left mui-icon-extra mui-icon-extra-notice alarmIcon" @click="toMsgCenter()"></a>
			<h1 class="mui-title mydefineTitle" id="mydefineTitle" @click="toFacade">区域名称
				<div class="triangle-right">
				</div>
			</h1>
			<a class="mui-pull-right mui-icon mui-icon-contact userIcon" @click="toUserCenter()"></a>
			<div class="energys">
				余额：<span class="bigNum" id="bigNum">0</span>元<span class="energySelect" @click="goPay" v-show='payFlag'>充值</span>
			</div>
		</header>
		<div class="mui-content" style="padding-top: 200px;">
			<p class="title">当月扣费记录明细
				<a class="mui-pull-right"  @click="toMore()">更多>&emsp;</a>
			</p>
			<ul class="mui-table-view"  v-if="sites.length>0">
			    <li class="mui-table-view-cell mui-media"  v-for="(site,index) in sites" :key="index">
			        <a href="javascript:;">
			            <div class="mui-media-body mui-pull-left">
			               	{{site.operation}}{{site.energy_type_name}}
			                <p class='mui-ellipsis'>{{site.record_time}}</p>
			            </div>
			            <div class="mui-media-body mui-pull-right mui-text-right">
			            	<!-- {{site.price}} -->
			                <p class='mui-ellipsis'>{{site.amount}}元</p>
			            </div>
			        </a>
			    </li>
			</ul>
			<div class="norecord" v-else>
				<img src="../assets/imgs/noInfo.png" class="noInfo"/>
				<p>暂无数据</p>
			</div>
		</div>	
    </div>
    <div v-else>
	    <header class="mui-bar mui-bar-nav">
			<a class="mui-icon mui-icon-left-nav mui-pull-left"></a>
			<h1 class="mui-title">区域列表</h1>
		</header>
		<div class="mui-content">
			<div class="norecord">
				<img src="../assets/imgs/noInfo.png" class="noInfo"/>
				<p>暂无区域</p>
			</div>
		</div>
	</div>
</template>
<script>
	import { Detail,GetFacadeList} from '@/request/api';
	var userPicker;
	export default{
		data: function(){
			return {
				myfade:true,
				sites: [],
				payFlag:false
			}
		},
		// created(){
		// 	this.getHalfYear();
		// },
		mounted() {
			var _this = this;
			//存在两种情况 一种是从url传递过来的参数， 另一中是登陆过来的参数。
			var urlInfo = this.$route.query;
			if(urlInfo.tenant_id){
				//表示已经微信认证成功过。
				sessionStorage.setItem("tenant_id",urlInfo.tenant_id);
				GetFacadeList({     
			    	"tenant_id":urlInfo.tenant_id,     
			   	}).then(res => {
			    	// 获取数据成功后的其他操作
			    	if(res.result =='true'){
			    		if(res.data.length>0){
			    			_this.myfade = true;
			    			//这才是正常的有区域的，否则后面的东西都会有问题。
			    			//设置session 并且赋初值。
			    			sessionStorage.setItem("facade",JSON.stringify({
			    				id:res.data[0].facade_id,
								name:res.data[0].facade_name,
								money:res.data[0].balance,
								is_online_pay:res.data[0].is_online_pay
			    			}));
							$("#mydefineTitle").html(res.data[0].facade_name+'<div class="triangle-right"></div>');
							$("#bigNum").html(res.data[0].balance);
							if(res.data[0].is_online_pay){
								_this.payFlag = true;
							}else{
								_this.payFlag = false;
							}
			    			//调用接口，获取半年的数据
			    			_this.getHalfYear();
			    			//获取用量和能耗数据。
			    			// _this.initEnergyPicker(res.data[0].facade_id);
			    		}else{
			    			_this.myfade = false;
			    			return false;
			    		}
			    	}
			    	else{
			    		mui.toast(res.description,{ duration:'long'});	
			    	}
		  		}) 
			}else{
				//表示第一次认证，并且session中肯定存在数据。
				//还需要判断是否已经选择过区域了。
				var facade = JSON.parse(sessionStorage.getItem("facade"));
				if(facade && facade.id){
					//直接正常的进行就行。
					$("#mydefineTitle").html(facade.name+'<div class="triangle-right"></div>');
					$("#bigNum").html(facade.money);
					this.myfade = true;
					this.getHalfYear();
					//获取用量和能耗数据。
	    			// this.initEnergyPicker(facade.id);
				}else{
					//需要获取区域列表，并且选择第一个进行赋初值，然后再调用接口获取半年的数据。
					GetFacadeList({     
				    	"tenant_id":sessionStorage.getItem("tenant_id"),     
				   	}).then(res => {
				    	// 获取数据成功后的其他操作
				    	if(res.result =='true'){
				    		if(res.data.length>0){
				    			_this.myfade = true;
				    			//这才是正常的有区域的，否则后面的东西都会有问题。
				    			//设置session 并且赋初值。
				    			sessionStorage.setItem("facade",JSON.stringify({
				    				id:res.data[0].facade_id,
									name:res.data[0].facade_name,
									money:res.data[0].balance,
									is_online_pay:res.data[0].is_online_pay
				    			}));
								$("#mydefineTitle").html(res.data[0].facade_name+'<div class="triangle-right"></div>');
								$("#bigNum").html(res.data[0].balance);
								//调用接口，获取半年的数据
								if(res.data[0].is_online_pay){
									_this.payFlag = true;
								}else{
									_this.payFlag = false;
								}
				    			_this.getHalfYear();
				    			//获取用量和能耗数据。
			    				// _this.initEnergyPicker(res.data[0].facade_id);
				    		}else{
				    			_this.myfade = false;
				    			return false;
				    		}
				    	}
				    	else{
				    		mui.toast(res.description,{ duration:'long'});	
				    	}
			  		}) 
				}
			}
            
      	},
		methods:{
			toFacade(){
				this.$router.push({path: '/facadeList'});
			},
			toMore(){
				this.$router.push({path: '/more'});
			},
			toUserCenter(){
				this.$router.push({path: '/userCenter'});
			},
			toMsgCenter(){
				this.$router.push({path: '/toMsgCenter'});
			},
			//充值。
			goPay(){
				this.$router.push({path: '/payMoney'});
			},
			getHalfYear(){
				//获取近半年的信息。
				//获取今天时间 以及半年前的日期
				var facade = JSON.parse(sessionStorage.getItem("facade"));
				var tenant_id = sessionStorage.getItem("tenant_id");
				Detail({     
			    	"energy_type_id":'',
			    	"facade_id":facade.id,
			    	'tenant_id':tenant_id,
			    	'starttime':getMonth(),
			    	'endtime':getToday(),
			    	'operation':'扣费'
			   	}).then(res => {
			    	// 获取数据成功后的其他操作
			    	if(res.result =='true'){
			    		this.sites = res.data;
			    	}
			    	else{
			    		mui.toast(res.description,{ duration:'long'});	
			    	}
		  		}) 
			}
		}
	}
</script>
<style>
	 @import '../common/css/public.css';
</style>


// WEBPACK FOOTER //
// src/pages/home.vue